function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M33.196 2.25h0L30 5.213 26.804 2.25h0a2.812 2.812 0 00-4.47.89h0l-1.82 3.959-4.085-1.513s0 0 0 0 0 0 0 0a2.814 2.814 0 00-3.791 2.532s0 0 0 0l-.166 4.354-4.354.166a2.815 2.815 0 00-2.532 3.79s0 0 0 0l1.513 4.086-3.96 1.82h0a2.815 2.815 0 00-.889 4.47h0L5.212 30 2.25 33.196s0 0 0 0a2.815 2.815 0 00.89 4.47l3.958 1.82-1.513 4.086a2.815 2.815 0 002.532 3.79s0 0 0 0l4.354.166.166 4.354s0 0 0 0a2.815 2.815 0 003.79 2.532l4.086-1.513 1.82 3.959s0 0 0 0a2.815 2.815 0 004.47.89L30 54.787l3.196 2.962h0a2.815 2.815 0 004.47-.89h0l1.82-3.959 4.086 1.513a2.815 2.815 0 003.79-2.532l.166-4.354 4.354-.166s0 0 0 0a2.814 2.814 0 002.532-3.79L52.9 39.485l3.959-1.82a2.815 2.815 0 00.89-4.47L54.787 30l2.962-3.196h0a2.815 2.815 0 00-.89-4.47h0l-3.959-1.82 1.513-4.085a2.815 2.815 0 00-2.532-3.791l-4.354-.166-.166-4.354a2.815 2.815 0 00-3.79-2.532s0 0 0 0L39.485 7.1l-1.82-3.96h0a2.811 2.811 0 00-4.47-.889zM20.442 7.255v-.001h0zM7.255 20.442h0zm-.097 18.883h0zm32.166 13.517h.001zm13.421-13.284h0zm1.926-9.684s0 0 0 0h0l-.135.126.135-.126zm-1.83-9.199h0z",
  fill: "url(#paint0_linear_5005_2929)",
  stroke: "#fff",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.689 24.198l-.83-.823H26.612V15.15h-5.261v29.884h5.26v-16.45h7.218l1.92 1.901v14.549h5.262V27.487l-3.323-3.29z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5005_2929",
  x1: "13.441",
  y1: "47.853",
  x2: "49.617",
  y2: "10.837",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B501B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#2A07F4"
})))));